import { API } from '../utils/api';
import { EnvironmentName } from '../types/quote';

export class BaseRepository {
  protected API: API;
  constructor(partnerID: string, productID: string, env?: EnvironmentName) {
    this.API = new API(partnerID, productID, env);
  }
}
